import useTranslation from 'next-translate/useTranslation'
import { workingTimes } from 'tennders-stracture/libs/utils'
import GHref from 'tennders-market/common/components/element/GHref'
import GDatePicker from 'tennders-common/form/components/date'
import { RouteType } from 'tennders-common/types/RouteType'
import React from 'react'
import GLocation from './GLocation'
import IconDeleteRound from '../../../../icons/icon-delete-round-f.svg'
import stylesInput from '@/styles/Input.module.scss'

type Props = {
  index ?: number,
  route ?: RouteType,
  locationLabel?: string,
  removeStop ?: (value : RouteType['identifier']) => void,
  onChange ?: (value : RouteType) => void,
  errors ?: Record<string, any>,
  minDate ?: string | Date,
  maxDate ?: string | Date,
  disabled ?: boolean,
  isPickUp ?: boolean,
  title ?: string,
  required ?: boolean
}

const GOfferRoute = (props : Props) => {
  const {
    index,
    route,
    locationLabel,
    removeStop,
    onChange,
    errors,
    minDate,
    maxDate,
    disabled,
    isPickUp,
    title,
    required
  } = props
  const { t } = useTranslation()
  const defaultTimes = workingTimes()

  return (
    <>
      {title && <h4><strong>{title}</strong></h4>}
      <>
        <GLocation
          google
          noDiv
          smart
          asInput
          disabled={disabled}
          className="mb-16 d-flex row mb-20 pos-rel"
          inputClass="form-input small w-100"
          error={errors && errors.location}
          onSet={(val) => onChange({ ...route, location: val })}
          value={route?.location?.label}
          type="autocomplete"
          name="location"
          label={locationLabel || t('route:location')}
          placeholder={t('route:countryZipCode')}
        />
        <div className="mb-16">
          <div className="d-flex">
            <label className="form-label">{isPickUp ? t('route:pickupDate') : t('route:deliveryDate')}</label>
            {required && <span className={stylesInput.required}>*</span>}
          </div>
          <div className="d-flex">
            <div className="mr-4">
              <GDatePicker
                disabled={disabled}
                eClass="d-flex"
                errors={errors}
                onlyInput
                className="form-input small mr-4"
                label={t('route:date')}
                maxDate={maxDate}
                minDate={minDate ? (typeof minDate === 'string' ? new Date(minDate) : minDate) : new Date()}
                onChange={(name, val) => onChange({ ...route, [name]: val })}
                name="date"
                value={route ? route.date || [] : []}
              />
            </div>
            <div className="mr-4">
              <GDatePicker
                disabled={disabled}
                errors={errors}
                timePicker
                onlyInput
                className="form-input small mr-4"
                label={t('route:from')}
                style={{ width: 100 }}
                onChange={(name, val) => onChange({ ...route, [name]: val })}
                name="timeFirst"
                value={(route && route.timeFirst && new Date(route.timeFirst)) || defaultTimes[0]}
              />
            </div>
            <div className="mr-4">
              <GDatePicker
                disabled={disabled}
                errors={errors}
                timePicker
                onlyInput
                className="form-input small"
                label={t('route:to')}
                style={{ width: 100 }}
                onChange={(name, val) => onChange({ ...route, [name]: val })}
                name="timeSecond"
                value={(route && route.timeSecond && new Date(route.timeSecond)) || defaultTimes[1]}
              />
            </div>
          </div>
        </div>
      </>
      <div>
        {index > 0 && !disabled && (
          <>
            <GHref className="d-flex align-center mt-16 mr-32 mb-16 btn-link" onClick={() => removeStop(route.identifier)}>
              <IconDeleteRound className="btn-only-icon" />
              {t('route:removeThisLocation')}
            </GHref>
            <div className="hr" />
          </>
        )}
      </div>
    </>
  )
}

export default GOfferRoute
